import React from "react";
import { Button, createStyles, Modal } from "@mantine/core";
import { useSelector } from "react-redux";

const useStyles = createStyles((theme) => ({
  modalFooter: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "1rem",
  },
  closeButton: {
    color:
      theme.colorScheme === "dark" || theme.colorScheme === "darkest"
        ? theme.colors.dark[2]
        : "black",
  },
  title: {
    fontWeight: "500",
    fontSize: "1.35rem",
  },
}));
const LogoutModal = ({ opened, close, userManager }) => {
  const language = useSelector((state) => state.language);
  const { classes } = useStyles();
  const handleLogout = () => userManager.signoutRedirect();
  return (
    <Modal
      opened={opened}
      onClose={close}
      title={language.Logout}
      centered
      size="md"
      closeButtonLabel={language.Close}
      classNames={{ close: classes.closeButton, title: classes.title }}
    >
      <span>{language.LogoutConfirm}</span>
      <div className={classes.modalFooter}>
        <Button onClick={close} color="dark" variant="subtle">
          {language.Abort}
        </Button>
        <Button className="primaryButton" onClick={handleLogout}>
          {language.Logout}
        </Button>
      </div>
    </Modal>
  );
};

export default LogoutModal;
